import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faTimes,
  faAngleDoubleLeft,
  faAngleDown,
  faAngleRight,
  faAngleUp,
  faCheck,
  faEdit,
  faExternalLinkAlt,
  faFileDownload,
  faFileUpload,
  faFileArrowUp,
  faKey,
  faStar,
  faCopy,
  faExclamationTriangle,
  faSync,
  faForward,
  faUserEdit,
  faUserTimes,
  faTrash,
  faMinus,
  faPaperPlane,
  faQuestionCircle,
  faRedo,
  faUndo,
  faPlay,
  faStop,
  faCheckDouble,
  faMapMarker,
  faBars,
  faPlus,
  faChevronRight,
  faArrowLeft,
  faArrowRight,
  faBuilding,
  faHouse,
  faHandHoldingDollar,
  faRectangleAd,
  faCircle,
  faCircleExclamation,
  faGear,
  faMagnifyingGlass,
  faImage,
  faBoxArchive,
  faQrcode,
  faCircleCheck,
  faCrown,
  faTrophy,
  faMoneyBill1,
  faBan,
  faThumbsUp,
  faThumbsDown,
} from "@fortawesome/free-solid-svg-icons";

import {
  faCcVisa,
  faCcMastercard,
  faCcDiscover,
  faCcAmex,
} from "@fortawesome/free-brands-svg-icons";
// @ts-ignore
library.add([
  faTimes,
  faAngleDoubleLeft,
  faAngleDown,
  faAngleRight,
  faAngleUp,
  faCheck,
  faEdit,
  faExternalLinkAlt,
  faFileDownload,
  faFileUpload,
  faFileArrowUp,
  faKey,
  faStar,
  faCopy,
  faExclamationTriangle,
  faSync,
  faForward,
  faUserEdit,
  faUserTimes,
  faTrash,
  faMinus,
  faPaperPlane,
  faQuestionCircle,
  faRedo,
  faUndo,
  faPlay,
  faStop,
  faCheckDouble,
  faMapMarker,
  faBars,
  faPlus,
  faChevronRight,
  faArrowLeft,
  faArrowRight,
  faBuilding,
  faHouse,
  faHandHoldingDollar,
  faRectangleAd,
  faCircle,
  faCircleExclamation,
  faGear,
  faMagnifyingGlass,
  faCcVisa,
  faCcMastercard,
  faCcDiscover,
  faCcAmex,
  faImage,
  faBoxArchive,
  faQrcode,
  faCircleCheck,
  faCrown,
  faTrophy,
  faMoneyBill1,
  faBan,
  faThumbsUp,
  faThumbsDown,
]);
